import data from './data.ts'

export default data;